import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const radialengineering: IBrand = {
  id: "radial-engineering",
  name: BRAND.RADIAL,
  logo: "/logo/radial-logo.jpeg",
  website: "https://www.radialeng.com/",
  description: `
Known for their reliable and hard-as-nails products.
  `
}